import { AdvicePriceCalculationResult } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { NeedName } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { isDefined } from "Utils/functions";
import { useAdvicePriceCalculationResults } from "../../hooks/stateSelectors";
import { mapToAdviceCoverageName } from "../mappers";

export const usePriceFromAkaAdvice = (
  needName: NeedName,
): AdvicePriceCalculationResult[] => {
  const advicePriceCalculationResults = useAdvicePriceCalculationResults();

  if (!isDefined(advicePriceCalculationResults)) {
    return [];
  }

  return advicePriceCalculationResults.filter((price) =>
    mapToAdviceCoverageName(needName).includes(price.configurationName),
  );
};
